import { useState, useEffect } from"react";
import { Link } from"react-router-dom";
import { Button } from"@/components/ui/button";
import { Calendar, LayoutDashboard } from"lucide-react";
import { ScheduleDemoDialog } from"./ScheduleDemoDialog";
import { supabase } from"@/integrations/supabase/client";

export const Header = () => {
 const [demoOpen, setDemoOpen] = useState(false);
 const [isSignedIn, setIsSignedIn] = useState(false);

 useEffect(() => {
 supabase.auth.getSession().then(({ data: { session } }) => {
 setIsSignedIn(!!session);
 });
 const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
 setIsSignedIn(!!session);
 });
 return () => subscription.unsubscribe();
 }, []);

 return (
 <header className="sticky top-0 z-50 border-b border-border bg-background">
 <div className="container mx-auto flex h-16 items-center justify-between px-4">
 {/* Logo */}
 <Link to="/" className="flex items-center gap-2.5">
 <img src="/logo.png" alt="Point Science Analytics" className="h-9 w-9 rounded-lg object-contain" />
 <span className="text-xl font-bold tracking-tight">Point Science Analytics</span>
 </Link>

 {/* Navigation */}
 <nav className="hidden items-center gap-8 md:flex">
 <a href="#features" className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary">
 Features
 </a>
 <a href="#pricing" className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary">
 Pricing
 </a>
 <a href="#how-it-works" className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary">
 How It Works
 </a>
 <Link to="/samples" className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary">
 Samples
 </Link>
 </nav>

 {/* Auth buttons */}
 <div className="flex items-center gap-3">
 {isSignedIn ? (
 <Button size="sm" className="glow-primary gap-1.5" asChild>
 <Link to="/dashboard">
 <LayoutDashboard className="h-3.5 w-3.5" />
 Dashboard
 </Link>
 </Button>
 ) : (
 <>
 <Button variant="outline" size="sm" className="gap-1.5 hidden sm:inline-flex" onClick={() => setDemoOpen(true)}>
 <Calendar className="h-3.5 w-3.5" />
 Book a Demo
 </Button>
 <Button variant="ghost" size="sm" asChild>
 <Link to="/auth">Sign In</Link>
 </Button>
 <Button size="sm" className="glow-primary" asChild>
 <Link to="/auth?mode=signup">Create account</Link>
 </Button>
 </>
 )}
 </div>
 </div>
 <ScheduleDemoDialog open={demoOpen} onOpenChange={setDemoOpen} />
 </header>
 );
};
